import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from 'src/app/shared/shared.module';
import { PermissionErrorComponent } from './permission-error.component';
import { PermissionErrorRoutingModule } from './permission-error-routing.module';
import { HeaderModule } from '../unauthorized/header/header.module';
import { FooterModule } from '../unauthorized/footer/footer.module';
@NgModule({
  declarations: [
    PermissionErrorComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    PermissionErrorRoutingModule,
    HeaderModule,
    FooterModule
  ]
})
export class PermissionErrorModule {
}


